var _rect, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestforcertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#F0F3F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_40342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -742,
    y: -4371,
    width: 1440,
    height: 8103,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -742,
    y: -4371,
    width: 1440,
    height: 8306,
    fill: "#F5F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -670,
    y: -1140,
    width: 1295,
    height: 1322,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0494 31.2361C47.4943 30.6664 47.6775 29.932 47.5524 29.2216C47.427 28.5112 47.0038 27.8837 46.391 27.5004C45.9081 27.1985 45.6924 26.6068 45.8685 26.0648C46.0916 25.3774 46.0128 24.6248 45.6518 23.9999C45.2912 23.375 44.6787 22.9304 43.9718 22.7798C43.4149 22.6614 43.0099 22.1788 42.9898 21.6098C42.9642 20.8872 42.6326 20.2071 42.0802 19.7434C41.5274 19.2793 40.8001 19.0712 40.0839 19.1714C39.5203 19.2509 38.9745 18.9356 38.761 18.4077C38.49 17.7375 37.9459 17.2115 37.2677 16.9648C36.5898 16.7181 35.8347 16.7711 35.1967 17.1103C34.6937 17.3775 34.0732 17.268 33.6919 16.8448C33.2083 16.308 32.517 16 31.7954 16C31.0738 16 30.3825 16.308 29.899 16.8448C29.5176 17.268 28.8972 17.3775 28.3942 17.1103C27.7562 16.7711 27.0011 16.7181 26.3232 16.9648C25.645 17.2115 25.1009 17.7375 24.8299 18.4077C24.6164 18.9356 24.0709 19.2509 23.507 19.1714C22.7911 19.0712 22.0635 19.2793 21.5107 19.7434C20.9579 20.2071 20.6266 20.8872 20.6011 21.6098C20.581 22.1788 20.1763 22.6614 19.6191 22.7801C18.9121 22.9304 18.2997 23.375 17.939 23.9999C17.5781 24.6248 17.4992 25.3774 17.7223 26.0648C17.8982 26.6068 17.6828 27.1985 17.1999 27.5007C16.5871 27.8837 16.1639 28.5112 16.0385 29.2216C15.9134 29.9324 16.0966 30.6664 16.5415 31.2364C16.8919 31.6852 16.8919 32.3152 16.5415 32.7639C16.0966 33.3336 15.9134 34.068 16.0385 34.7784C16.1639 35.4892 16.5871 36.1163 17.1999 36.4996C17.6828 36.8015 17.8985 37.3932 17.7227 37.9352C17.4992 38.6226 17.5784 39.3752 17.939 40.0001C18.3 40.625 18.9121 41.0696 19.6191 41.2202C20.1763 41.3386 20.581 41.8212 20.6011 42.3905C20.6266 43.1128 20.9582 43.7932 21.511 44.257C22.0638 44.7207 22.7915 44.9291 23.507 44.8286C24.0709 44.7497 24.6164 45.0644 24.8299 45.5926C25.1009 46.2625 25.6453 46.7885 26.3232 47.0352C27.0014 47.2819 27.7562 47.2289 28.3945 46.89C28.5784 46.792 28.7785 46.7448 28.9764 46.7448C29.3194 46.7448 29.6571 46.8868 29.899 47.1552C30.3829 47.6923 31.0742 48 31.7954 48C32.517 48 33.2083 47.692 33.6922 47.1552C34.0732 46.732 34.6937 46.6228 35.1967 46.89C35.835 47.2292 36.5898 47.2819 37.268 47.0352C37.9459 46.7885 38.49 46.2625 38.761 45.5926C38.9745 45.0644 39.5203 44.7494 40.0842 44.8286C40.7997 44.9288 41.5274 44.7207 42.0802 44.257C42.633 43.7932 42.9646 43.1128 42.9901 42.3905C43.0099 41.8212 43.4149 41.3389 43.9718 41.2202C44.6787 41.0696 45.2912 40.625 45.6522 40.0001C46.0128 39.3752 46.0916 38.6226 45.8685 37.9352C45.6927 37.3935 45.9081 36.8015 46.391 36.4996C47.0041 36.1163 47.4273 35.4892 47.5527 34.7787C47.6778 34.068 47.4946 33.3339 47.0497 32.7639C46.699 32.3148 46.699 31.6852 47.0494 31.2361ZM31.7954 42.8753C25.7989 42.8753 20.9199 37.9967 20.9199 32.0002C20.9199 26.0033 25.7989 21.1247 31.7954 21.1247C37.792 21.1247 42.6706 26.0033 42.6706 32.0002C42.6706 37.9967 37.792 42.8753 31.7954 42.8753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7955 23.6074C27.1674 23.6074 23.4023 27.3725 23.4023 32.0005C23.4023 36.6283 27.1674 40.3933 31.7955 40.3933C36.4235 40.3933 40.1883 36.6283 40.1883 32.0005C40.1883 27.3725 36.4232 23.6074 31.7955 23.6074ZM26.553 30.4609C27.0378 29.9761 27.8236 29.9761 28.3084 30.4609L30.7818 32.9344L35.2825 28.4337C35.7673 27.9489 36.5531 27.9489 37.0379 28.4337C37.5227 28.9182 37.5227 29.7042 37.0379 30.1887L31.6595 35.5674C31.4268 35.8001 31.1109 35.9309 30.7818 35.9309C30.4528 35.9309 30.1371 35.8001 29.9042 35.5674L26.5534 32.2163C26.0682 31.7315 26.0682 30.9457 26.553 30.4609Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -741.5,
    y: -4370.5,
    width: 1439,
    height: 8102,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -5121,
    y: -13502,
    width: 53660,
    height: 41487,
    stroke: "black",
    strokeWidth: 50
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_40342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -742,
    y: -4371,
    width: 1440,
    height: 8103,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestforcertificate);
export default __webpack_public_path__ + "static/media/request for certificate.cec04c848859473d5268ad6b4870fd84.svg";
export { ForwardRef as ReactComponent };